module.exports = __webpack_public_path__ + "static/media/roomc2.866842e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/roomc2.jpg
// module id = 890
// module chunks = 0